import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import TextToolTip from '@components/TextToolTip/TextToolTip';
import { Box, useTheme } from '@mui/material';
import { Container } from './Card.styles';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

export interface CardProps {
  title?: string;
  subtitle?: string;
  tooltipText?: string;
  className?: string;
}

const Card = ({
  title,
  subtitle,
  tooltipText,
  children,
  className,
}: React.PropsWithChildren<CardProps>) => {
  const theme = useTheme();

  return (
    <Container className={className}>
      <Flex flex={1} justifyContent='space-between' alignItems='baseline' width='100%'>
        <Flex flexDirection='column'>
          <Text variant='h6' fontWeight='fontWeightBold'>
            {title}
          </Text>
          <Text variant='body' fontWeight='fontWeightSemiBold' color={theme.palette.grey[700]}>
            {subtitle}
          </Text>
        </Flex>
        {tooltipText ? (
          <TextToolTip
            text=''
            toolTipText={tooltipText}
            icon={() => (
              <ErrorOutlineRoundedIcon
                sx={{ color: theme.palette.grey[700] }}
              />
            )}
          />
        ) : null}
      </Flex>
      <Box>{children}</Box>
    </Container>
  );
};

export default Card;
